import classnames from 'classnames/bind';
import styles from './emptyResult.module.scss';

const cx = classnames.bind(styles);

const EmptyResult = () => {
  return (
    <div className={cx('emptyResultArea')}>
      <div className={cx('emptyResultWrap')}>
        <em className={cx('title')}>아직 응시이력이 없습니다.</em>
        <p className={cx('desc')}>개발자 검사를 응시하고 결과표를 확인해보세요.</p>
      </div>
    </div>
  );
};

export default EmptyResult;
